<template>
  <validation-observer tag="div" class="container" @submit.native.prevent ref="validation">
    <div class="card mt-4">
      <div class="card-body" @submit.prevent>
        <h2 class="mb-4">Integration Details</h2>
        <p class="text-muted mb-4">
          Based on the Trigger selected (initial fault or resolution), we
          will send a POST request to the specified URL endpoint.
          <br />
          This request will include a Bearer Token in the header and the
          payload as shown in the example below.
        </p>

        <integration-code-snippet />

        <div class="mb-3">
          <validation-provider name="name" vid="name" rules="required">
            <label class="form-label">Integration Name</label>
            <c-input type="text" v-model="stateName" />
            <c-help-block />
          </validation-provider>
        </div>

        <div class="mb-3">
          <label class="form-label">Trigger</label>
          <c-input as="multiselect" placeholder :options="triggerOptions" :preselect-first="true" :show-labels="false"
            :allow-empty="false" label="name" v-model="trigger" />
        </div>

        <div class="mb-3">
          <validation-provider name="url" vid="url" rules="required">
            <label class="form-label">URL</label>
            <c-input type="text" v-model="stateUrl" />
            <c-help-block />
          </validation-provider>
        </div>

        <div class="mb-3">
          <validation-provider name="token" vid="token" rules="required">
            <label class="form-label">Token</label>
            <c-input type="text" v-model="stateToken" />
            <c-help-block />
          </validation-provider>
        </div>
        <div v-if="$can('write integrations')" class="hstack mt-4">
          <router-link :to="{ name: 'settings.integrations' }"
            class="btn btn-outline-primary me-auto">Cancel</router-link>
          <c-button type="submit" @click="save" validate>Save Integration</c-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/integrations'
import IntegrationCodeSnippet from '@/components/settings/IntegrationCodeSnippet'
import { toast } from '@chameleon/chameleon-vue'

export default {
  mixins: [
    stateMapper
  ],

  data () {
    return {
      triggerOptions: [
        { name: 'Initial Fault', value: 'initial_fault' },
        { name: 'Resolution', value: 'resolution' }
      ],
    }
  },

  components: {
    IntegrationCodeSnippet,
  },

  computed: {
    ...helperComputed,

    trigger: {
      get () {
        return this.triggerOptions.find(({ value }) => value === this.stateTrigger)
      },

      set ({ value }) {
        this.stateTrigger = value
      }
    },
  },

  methods: {
    ...helperMethods,

    async save () {
      await this.updateIntegration({
        id: this.integration.id,
        payload: {
          name: this.stateName,
          trigger: this.trigger.value,
          url: this.stateUrl,
          token: this.stateToken,
        }
      })
      toast('Successfully updated integration', 'success')
    }
  }
}
</script>
